import styled, { css } from 'styled-components';
import { suppressProps } from '../../utils/index.js';
const alignContent = (props) => {
    if (props.wrap === 'wrap' || props.wrap === 'wrap-reverse') {
        return css `
      align-content: ${props.alignContent};
    `;
    }
    return {};
};
export const FlexElement = styled.div.withConfig(suppressProps('align', 'alignContent', 'direction', 'inline', 'justify', 'justifySafe', 'wrap'))(({ align, direction, inline, justify, justifySafe, wrap, }) => css `
    display: ${inline ? 'inline-flex' : 'flex'};
    flex-direction: ${direction};
    align-items: ${align};
    justify-content: ${justify} ${justifySafe};
    flex-wrap: ${wrap};
  `, alignContent);
//# sourceMappingURL=flex.styles.js.map